// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_359595d4"};